module.exports = __webpack_public_path__ + "assets/4338c310fd371b6e124213a9246d5706.jpg";